import { render, staticRenderFns } from "./Cadu.vue?vue&type=template&id=6f4c79b1"
import script from "./Cadu.vue?vue&type=script&lang=js"
export * from "./Cadu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports